import { render, staticRenderFns } from "./PoTransactionDataView.vue?vue&type=template&id=7e97fc4e&scoped=true&"
import script from "./PoTransactionDataView.vue?vue&type=script&lang=js&"
export * from "./PoTransactionDataView.vue?vue&type=script&lang=js&"
import style0 from "./PoTransactionDataView.vue?vue&type=style&index=0&id=7e97fc4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e97fc4e",
  null
  
)

export default component.exports